module.exports = __webpack_public_path__ + "img/p1.0e089d1f.png";